import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					title={"Mens Health WA"}
					image={require('./video.jpg')}
					// video={{ mp4: require('../../ContactUs/video.mp4'), webm: require('../../ContactUs/video.webm')}}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">A fantastic WA not profit organisation looking for a fresh new look.</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/mens-health-wa.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Together with the CEO and Board, Moshi Moshi undertook a comprehensive rebranding process with the aim of providing Men’s Health and Wellbeing with a look and feel that would resonate with both the recipients and sponsors.</div>
								<ul className="with-icons">
									<li>Branding</li>
									<li>Website <a href="https://www.menshealthwa.org.au" target="_blank">www.menshealthwa.org.au</a></li>
									<li>Custom designed for visual impact</li>
									<li>Responsive design to work on all devices</li>
									<li>Brochures</li>
									<li>Posters</li>
									<li>Business Cards</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Mens Health WA Feature" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Mens Health WA Feature" width="100%" />
								<img src={require('./example-2.jpg')} alt="Mens Health WA Feature" width="100%" />
								<img src={require('./example-3.jpg')} alt="Mens Health WA Feature" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/MensHealthWA/index.js